import { TableRow, TableRowProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { muiPalette } from '@/shared/general-theme';

interface StyledBodyRowProps extends TableRowProps {
  disabled?: boolean;
  clickable?: boolean;
}

export const StyledBodyRow = styled(
  TableRow,
  {
    shouldForwardProp: (prop) => prop !== 'clickable' && prop !== 'disabled',
  },
)<StyledBodyRowProps>(
  ({ disabled, clickable }) => (
    {
      ...(
        disabled && {
          pointerEvents: 'none',
          opacity: 0.5,
          backgroundColor: muiPalette.action?.disabledBackground,
        }
      ),
      ...(
        clickable && {
          '& .MuiTableCell-root': {
            cursor: 'pointer',
          }
        }
      ),
    }
  ));